import { LegalPageLayout } from "./LegalPageLayout";

export default function MentionsLegales() {
  return (
    <LegalPageLayout title="Mentions Légales">
      <h2>Éditeur du site</h2>
      <p>
        <strong>Libaddict</strong><br />
        Auto-entrepreneur : Valentin PARAGE<br />
        Adresse : 11 rue Villedo, 75001 Paris<br />
        SIRET : 947 494 993 00027<br />
        Email : conception.vpdev@gmail.com<br />
        Téléphone : sur demande auprès de l'éditeur<br />
        Site : <a href="https://libaddict.com">https://libaddict.com</a>
      </p>

      <h2>Hébergement</h2>
      <p>
        Le site est hébergé par IONOS, infrastructure Supabase, prestataire d'hébergement 
        et de gestion de données sécurisées.<br />
        Supabase assure la disponibilité, la sécurité et la sauvegarde des données 
        dans le respect des normes RGPD.
      </p>

      <h2>Directeur de la publication</h2>
      <p>Valentin PARAGE</p>

      <h2>Délégué à la Protection des Données (DPO)</h2>
      <p>
        Pour toute question relative à la protection de vos données personnelles, 
        vous pouvez contacter : <a href="mailto:conception.vpdev@gmail.com">conception.vpdev@gmail.com</a>
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu du site (textes, logos, illustrations, charte graphique, 
        structure et code) est la propriété exclusive de Libaddict. Toute reproduction, 
        représentation, modification, publication, adaptation de tout ou partie des 
        éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite 
        sans autorisation écrite préalable.
      </p>

      <h2>Responsabilité</h2>
      <p>
        Libaddict met tout en œuvre pour offrir un service sécurisé et conforme, 
        mais ne saurait être tenue responsable de tout dommage direct ou indirect 
        résultant de l'utilisation du site, notamment en cas d'interruption du service, 
        de bug ou d'erreur de données.
      </p>
    </LegalPageLayout>
  );
}
